import React from 'react';
import DrayageQuoteForm from './DrayageQuoteForm';

const DrayageQuotePage = () => {
  return (
    <div>
      <DrayageQuoteForm />
    </div>
  );
};

export default DrayageQuotePage;
